import React, { useEffect, useMemo, useState } from "react";
import Icon from "../../icons/Icon";
import styles from "./helpText.module.scss";
import { CheckmarkP500, Error } from "../../icons/18";

const HelpText = ({
  resultObj = { result: "", message: "" },
  showHelpTextError = false,
  showHelpTextSuccess = false,
  helpTextComponent,
  fontSize = 12,
  className,
}: {
  showHelpTextError?: boolean;
  showHelpTextSuccess?: boolean;
  resultObj?: { [key: string]: string };
  helpTextComponent?: React.ReactNode;
  fontSize?: number;
  className?: string;
}) => {
  // 결과 객체 변경 시 상태 변경
  const [currentResultObj, setCurrentResultObj] = useState(resultObj);
  useEffect(() => {
    if (resultObj && currentResultObj) {
      const check = Object.keys(resultObj).some((key) => {
        if (resultObj[key] !== currentResultObj[key]) {
          return true;
        }
      });
      if (check) {
        setCurrentResultObj(resultObj);
      }
    }
  }, [resultObj]);

  // 헬프 텍스트 노출 조건 1) 헬프 텍스트 컴포넌트가 있거나 2) 에러 메세지 노출 여부 true + 유효한 에러 메세지가 있는 경우 3) 성공 메세지 노출 여부 true + 유효한 성공 메세지가 있는 경우
  const helpTextCondition = useMemo(() => {
    return (
      helpTextComponent ||
      (showHelpTextError && currentResultObj?.result === "error" && currentResultObj?.message) ||
      (showHelpTextSuccess && currentResultObj?.result === "success" && currentResultObj?.message)
    );
  }, [helpTextComponent, showHelpTextError, showHelpTextSuccess, currentResultObj]);

  // Help Text
  const HelpTextComponent = useMemo(() => {
    return (
      <div
        className={`${styles["input-help-text"]} ${styles[`font-${fontSize}`]} ${className ? className : ""}`}
      >
        {showHelpTextError && currentResultObj?.message && currentResultObj?.result === "error" ? (
          <>
            <b className={`${styles[currentResultObj?.result]}`}>
              {currentResultObj?.result === "error" && <Icon size={18} IconComponent={<Error />} />}
              <span>{currentResultObj.message}</span>
            </b>
          </>
        ) : showHelpTextSuccess &&
          currentResultObj?.message &&
          currentResultObj?.result === "success" ? (
          <>
            <b className={`${styles[currentResultObj?.result]}`}>
              {currentResultObj?.result === "success" && (
                <Icon size={18} IconComponent={<CheckmarkP500 />} />
              )}
              <span>{currentResultObj?.message}</span>
            </b>
          </>
        ) : (
          helpTextComponent
        )}
      </div>
    );
  }, [helpTextComponent, showHelpTextError, showHelpTextSuccess, currentResultObj]);

  return helpTextCondition && <>{HelpTextComponent}</>;
};

export default HelpText;
